module.exports = __webpack_public_path__ + "fonts/analogue-webfont.07c85cd.ttf";